function initializeMagico(root = document) {
  root.querySelectorAll('[data-magico-product]').forEach(section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    section.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
      const image = section.querySelector('.mg-gallery__image');
      image.removeAttribute('srcset');
      image.src = button.dataset.image;
      image.alt = button.dataset.imageAlt;
      section.querySelectorAll('[data-image]').forEach(item => {
        item.classList.toggle('is-active', item === button);
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
    }));
    const lightbox = section.querySelector('[data-magico-lightbox]');
    section.querySelector('[data-magico-zoom]')?.addEventListener('click', () => {
      const image = section.querySelector('.mg-gallery__image');
      const enlarged = lightbox.querySelector('[data-magico-lightbox-image]');
      enlarged.src = image.currentSrc || image.src;
      enlarged.alt = image.alt;
      lightbox.showModal();
    });
    section.querySelector('[data-magico-close]')?.addEventListener('click', () => lightbox.close());
    lightbox?.addEventListener('click', event => {
      if (event.target === lightbox) {
        const box = lightbox.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) lightbox.close();
      }
    });
    section.querySelector('[data-magico-variant]')?.addEventListener('change', event => {
      const option = event.target.selectedOptions[0];
      section.querySelector('[data-magico-price]').textContent = option.dataset.price;
      document.querySelectorAll('[data-magico-inquiry-finish]').forEach(input => input.value = option.dataset.title);
      const url = new URL(location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
    });
  });
}
initializeMagico();
document.addEventListener('shopify:section:load', event => initializeMagico(event.target));

if (!window.magicoStickyBound) {
  window.magicoStickyBound = true;
  let queued = false;
  const updateMagicoNavigation = () => {
    queued = false;
    let offset = 0;
    document.querySelectorAll('header, .header, .halo-header, .section-header-navigation').forEach(header => {
      const position = getComputedStyle(header).position;
      const box = header.getBoundingClientRect();
      if ((position === 'fixed' || position === 'sticky') && box.top <= 0 && box.bottom > 0 && box.height < innerHeight / 2) offset = Math.max(offset, box.bottom);
    });
    document.querySelectorAll('.mg-nav--sticky').forEach(nav => {
      nav.style.setProperty('--mg-nav-offset', offset + 'px');
      const wrapper = nav.closest('.shopify-section');
      wrapper?.classList.add('mg-sticky-section');
      wrapper?.style.setProperty('--mg-section-offset', offset + 'px');
    });
  };
  const queueNavigation = () => {
    if (!queued) { queued = true; requestAnimationFrame(updateMagicoNavigation); }
  };
  addEventListener('scroll', queueNavigation, { passive: true });
  addEventListener('resize', queueNavigation);
  document.addEventListener('shopify:section:load', queueNavigation);
  queueNavigation();
}